import { render, staticRenderFns } from "./CampaignSetupPixelsDomain.vue?vue&type=template&id=c1ee8972&"
import script from "./CampaignSetupPixelsDomain.vue?vue&type=script&lang=js&"
export * from "./CampaignSetupPixelsDomain.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSetupPixelsDomain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports